import { useEffect } from 'react';

import useDidMount from '../../../hooks/useDidMount';
import { BaseRootStore } from '../../rootStore/baseRootStore';
import { calculateTotalUsedArea } from '../helpers/functions/totalUsedArea';

export default function useTotalUsedArea(rootStore: BaseRootStore) {
  const { userStore, areaUnitStore } = rootStore;
  const { areaUnit } = areaUnitStore;

  const totalUsedArea = calculateTotalUsedArea(
    userStore.userDataTotalArea.area,
    userStore.userDataOrganizations.orgs,
    userStore.combinedData.userData?.uuid ?? '',
  );

  useDidMount(() => {
    void userStore.fetchCombinedData();
  });

  useEffect(() => {
    if (!areaUnit) {
      return;
    }

    void userStore.fetchOrganizationsUsers({ areaUnit });
    void userStore.fetchUserTotalArea({ areaUnit });
  }, [areaUnit, userStore]);

  return {
    loading:
      userStore.combinedData.loading ||
      userStore.userDataOrganizations.loading ||
      userStore.userDataTotalArea.loading,
    loaded:
      userStore.combinedDataLoaded &&
      userStore.userDataOrganizationsLoaded &&
      userStore.userDataTotalAreaLoaded,
    totalUsedArea,
  };
}
